import React from 'react';

const SrivatsaPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white">

      <img
        src="/srivatsa.svg"
        alt="Śrivatsa Symbol"
        className="w-[calc(100vw-80px)] h-[calc(100vw-80px)] sm:w-80 sm:h-80 md:w-96 md:h-96 lg:w-[36rem] lg:h-[36rem]"
      />
      <div className="space-y-5 md:space-y-6 w-full px-6 text-center mt-10">
        <p className="text-base sm:text-lg md:text-lg lg:text-xl font-ogg-light">
          our purpose is in the art of sense-making
        </p>
        <p className="text-base sm:text-lg md:text-lg lg:text-xl font-ogg-light">
          locality meets infinity – physical meets digital – wisdom meets compassion
        </p>
        <p className="text-base sm:text-lg md:text-lg lg:text-xl font-ogg-light">
          cultivating clarity, meaningful connection and profound consciousness within our commUnity
        </p>
      </div>
    </div>
  );
};

export default SrivatsaPage;
